import AirbrakeJs from 'airbrake-js'

class FakeAirbrakeJs {
  notify () {}
}

let airbrake
if (__NODE_ENV__ === 'test') {
  airbrake = new FakeAirbrakeJs()
} else {
  airbrake = new AirbrakeJs({
    projectId: __AIRBRAKE_PROJECT_ID__,
    projectKey: __AIRBRAKE_PROJECT_KEY__,
    onerror: false
  })
  airbrake.addFilter((notice) => {
    if (__NODE_ENV__ === 'development') {
      console.error('Airbrake', notice)
      return null
    }
    notice.context.environment = __API_ENV__
    notice.context.version = __PEK_VERSION__
    return notice
  })
}

export default airbrake



// WEBPACK FOOTER //
// ./src/initializers/Airbrake.js